/* eslint-disable */
import {
  Button,
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
  Dropdown,
  Modal,
  message,
} from "antd";
import React, { useEffect, useRef, useState,useMemo } from "react";
import {
  CaretDownOutlined,
  EditOutlined,
  DeleteOutlined,
  OneToOneOutlined,
  MenuOutlined,
  SyncOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { CustomTable } from "@/hocComponents";
import AddModal from "./component/AddModal";

export default function TypeJob() {
  const addModalRef = useRef(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const childRef = useRef();
  const [tableLoading, setTableLoading] = useState(false);
  const [tableList, setTableList] = useState([]);
  const [loading, setLoading] = useState(false);
  const pageSizeRef = useRef(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); 
  const [glChartNameOptions, setGlChartNameOptions] = useState([]);
  const [acctTypeOptions, setAcctTypeOptions] = useState([]);
  const [noPostOptions, setNoPostOptions] = useState([]);
  const [type1099Options, setType1099Options] = useState([]);
  const [subTypeOptions, setSubTypeOptions] = useState([]);
  const [dictLoading, setDictLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  const loadAccDictList = async () => {
     setDictLoading(true);
    try {
      const [glChartNameRes, acctTypeRes, noPostRes, type1099Res, glAcctSubRes] = await Promise.all([
        http.get(api.getFieldMapping, { params: { field: "gl_chart_name" } }),
        http.get(api.getFieldMapping, { params: { field: "acct_type" } }),
        http.get(api.getFieldMapping, { params: { field: "no_post" } }),
        http.get(api.getFieldMapping, { params: { field: "type1099" } }),
        http.get(api.getFieldMapping, { params: { field: "gl_acct_sub_type" } }),
      ]);

      const glChartNameList = (glChartNameRes.data || []).map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setGlChartNameOptions(glChartNameList);

      const acctTypeList = (acctTypeRes.data || []).map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setAcctTypeOptions(acctTypeList);

      const noPostList = (noPostRes.data || []).map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setNoPostOptions(noPostList);

      const type1099List = (type1099Res.data || []).map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setType1099Options(type1099List);

      const glAcctSubList = (glAcctSubRes.data || []).map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setSubTypeOptions(glAcctSubList);
    } catch (error) {
      message.error("Failed to load dictionary data");
    }finally {
    setDictLoading(false); 
  }
  };

  // table
  const initTableHead = {
    bankGroup: null,
    remark: null,
    createByName: null,
    updateByName: null,
    active: null,
    orderField: null,
    orderType: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  // 批量删除功能
  const handleBatchDelete = () => {
    if (selectedRowKeys.length === 0) {
      message.warning("Please select at least one item to delete");
      return;
    }

    Modal.confirm({
      className: "commonModal",
      title: "Complete Request",
      icon: <ExclamationCircleOutlined />,
      content: <span>Are you sure to delete the selected {selectedRowKeys.length} item(s)?</span>,
      okText: "Sure",
      cancelText: "Cancel",
      async onOk() {
        setLoading(true);
        try {
          const response = await http.post(api.getGLChartDelete, {
            ids: selectedRowKeys,
          });
          if (response.code === "1") {
            message.success(`Successfully deleted ${selectedRowKeys.length} item(s).`);
            setSelectedRowKeys([]); 
            getTableListFn(pagination.current, pagination.pageSize, tableHead);
          } else {
            message.error(response?.msg || "Delete failed.");
          }
        } catch (error) {
          message.error("An error occurred. Please try again.");
        } finally {
          setLoading(false);
        }
      },
      onCancel() {},
      style: {
        top: "40%",
      },
    });
  };

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "action",
      hidden: false,
      align: "center",
      width: 50,
      render: (text, record) =>
        (commonFn.btnAuthorityFlag("Edit") ||
          commonFn.btnAuthorityFlag("Delete")) && (
          <Dropdown
            menu={{
              items: [
                commonFn.btnAuthorityFlag("Edit") && {
                  key: "edit",
                  icon: (
                    <EditOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Edit </div>,
                },
              ].filter(Boolean),
              onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>
        ),
    },
    {
      title: "Gl Chart Name",
      dataIndex: "glChartName",
      titleType: "Select",
      isSorter: true,
       width: 160,
      selectOptions: glChartNameOptions,
      onChange: (value) => tableFilterFn(value, "glChartNameId", "Select"),
    },
    {
      title: "GL Account",
      dataIndex: "glAcct",
      titleType: "Input",
      isSorter: true,
      width:140,
      onChange: (e) => tableFilterFn(e, "glAcct"),
    },
    { 
      title: "Title",
      dataIndex: "title",
      titleType: "Input",
      isSorter: true,
      width:250,
      onChange: (e) => tableFilterFn(e, "title"),
    },
    {
  title: "Account Type",
  dataIndex: "acctType",
  titleType: "Select",
  isSorter: true,
  width:120,
  selectOptions: acctTypeOptions,
  onChange: (value) => tableFilterFn(value, "acctType", "Select"),
  render: (value) => {
    const option = acctTypeOptions.find(item => item.value === value);
    return option ? option.label : value; 
  }
},
    {
      title: "Sub Type",
      dataIndex: "glAcctSubTypeName",
      titleType: "Select",
      isSorter: true,
      width:120,
      selectOptions: subTypeOptions,
      onChange: (value) => tableFilterFn(value, "glAcctSubTypeName", "Select"),
    },
    {
      title: "NoPost",
      dataIndex: "noPost",
      titleType: "Select",
      isSorter: true,
      width:90,
      selectOptions: noPostOptions,
      onChange: (value) => tableFilterFn(value, "noPost", "Select"),
      render: (value) => (value === "Y" ? "Yes" : "No")
    },
    {
      title: "Type 1099",
      dataIndex: "type1099",
      titleType: "Select",
      isSorter: true,
      width:100,
      selectOptions: type1099Options,
      onChange: (value) => tableFilterFn(value, "type1099", "Select"),
      render: (value) => (value === "Y" ? "Yes" : "No"),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      titleType: "Input",
      isSorter: true,
      width:180,
      onChange: (e) => tableFilterFn(e, "remarks"),
    },
  ];
  // const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));
const columns = useMemo(() => {
  return commonFn.handleColunmFn(initColumns);
}, [
  glChartNameOptions,
  acctTypeOptions,
  subTypeOptions,
  noPostOptions,
  type1099Options,
]);
  // 调用子组件showModal方法
  const showModalAdd = () => {
    addModalRef.current?.setModelAdd();
  };

  const showModalThree = () => {
    if (
      childRef.current &&
      typeof childRef.current.clearInputs === "function"
    ) {
      childRef.current.clearInputs();
      childRef.current.newListFun();
    }
  };

  const handleMenuClick = async (e, record) => {
    if (e.key === "edit") {
      addModalRef.current?.setModelEdit(record);
    }
  };

  // 处理选项变化
  const handleTableChange = (pagination, filters, sorter) => {
    pageSizeRef.current = pagination.pageSize;
    const { field: orderField, order: orderType } = sorter;
    const tableHeadTemp = {
      ...tableHead,
      orderField: orderField || "",
      orderType: orderType || "",
    };
    getTableListFn(pagination.current, pageSizeRef.current, tableHeadTemp);
  };

  // 行选择配置
const rowSelection = {
  selectedRowKeys: selectedRowKeys,
  onChange: (selectedKeys, selectedRows) => {
  
    setSelectedRowKeys(selectedKeys);
  },
  getCheckboxProps: (record) => ({
  
  }),
};

  const handleChange = (checkedValues) => {
    console.log(checkedValues);
    setSelectedItems(checkedValues);
    if (childRef.current) {
      childRef.current.toggleColumnVisibility(checkedValues);
    }
  };

  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  // 获取列表数据
  const getTableListFn = async (current, pageSize, searchParams = {}) => {
    setTableLoading(true);
    try {
      const queryParams = {
        page: current || pagination.current,
        count: pageSize || pagination.pageSize,
        ...searchParams,
      };

      Object.keys(queryParams).forEach((key) => {
        if (
          queryParams[key] === null ||
          queryParams[key] === undefined ||
          queryParams[key] === ""
        ) {
          delete queryParams[key];
        }
      });

      const response = await http.get(api.getGLChartShow, {
        params: queryParams,
      });

      if (response?.code !== "1") {
        commonFn.modalFailedFn(response);
        setTableLoading(false);
        return;
      }

      const data = response.data || {};
      const list = (data.list || []).map((item) => ({
        ...item,
        key: item.glChartId,
      }));
      setTableList(list);

      setPagination({
        current: data.pageNum || current || 1,
        pageSize: data.pageSize || pageSize || 25,
        total: data.total || 0,
      });
    } catch (error) {
      message.error("Failed to fetch data");
    } finally {
      setTableLoading(false);
    }
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

 useEffect(() => {
  initColunmsFn();
  const initData = async () => {
    await loadAccDictList();
    getTableListFn(1, 25);
  };
  initData();
}, [refreshKey]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          <Space size="large">
            {commonFn.btnAuthorityFlag("New") && (
              <Button className="btnNew" onClick={showModalAdd}>
                <PlusOutlined />
                New
              </Button>
            )}
            {commonFn.btnAuthorityFlag("Delete") && (
              <Button 
                danger
                type="primary"
                onClick={handleBatchDelete}
                loading={loading}
              >
                <DeleteOutlined />
                Delete {selectedRowKeys.length > 0 && `(${selectedRowKeys.length})`}
              </Button>
            )}
          </Space>
        </div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>

      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading || dictLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollX={1210}
        tableScrollY="350px"
        tableCss="maintenanceTable"
        rowKey="glChartId" 
        rowSelection={rowSelection} 
      />
      <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />
    </div>
  );
}